






















































import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import AbortButton from "@/components/Button/AbortButton.vue";
import SaveButton from "@/components/Button/SaveButton.vue";
import FscCard from "@/components/Card/FscCard.vue";
import Validation from "@/components/Validation.vue";
import { Validations } from "vuelidate-property-decorators";
import { namespace } from "vuex-class";
import CompanyMixin from "@/mixins/CompanyMixin";
import { requiredIf, helpers } from "vuelidate/lib/validators";
import { checkFileSizeBeforeUpload } from "@/helper/files";
import { UploadConfiguration } from "@/enums/UploadConfiguration";
import TabMixin from "@/mixins/TabMixin";

const optionalUrl = helpers.withParams({ type: "optionalUrl" }, (value: string) => {
  if (!value) return true;
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
});

const UnterrichtDashboardModule = namespace("unterricht-dashboard");

@Component({
  components: {
    Validation,
    AbortButton,
    SaveButton,
    FscCard,
  },
})
export default class UnterrichtWidgetForm extends mixins(CompanyMixin, TabMixin) {
  public name = "UnterrichtWidgetForm";

  @UnterrichtDashboardModule.Action("findAllWidgets")
  public findWidgets: any;

  @UnterrichtDashboardModule.Action("updateWidgets")
  public updateWidgets: any;

  @UnterrichtDashboardModule.Action("uploadWidgetImg")
  public uploadWidgetImg: any;

  @UnterrichtDashboardModule.Getter("getIsLoading")
  public isLoading: any;

  @UnterrichtDashboardModule.Getter("getDataList")
  public userWidgets: any;

  private fullPath: string | undefined = undefined;

  private fileSizeInvalid: boolean[] = [false, false, false];

  private widget: any = [
    { title: "", description: "", linkUrl: "", file: null },
    { title: "", description: "", linkUrl: "", file: null },
    { title: "", description: "", linkUrl: "", file: null },
  ];

  public onSelectedImageBeforeSubmit(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0] || null;

    if (file) {
      this.widget[index].file = file;

      const isTooLarge = !checkFileSizeBeforeUpload(file, UploadConfiguration.SIZE_NORMAL);
      this.fileSizeInvalid[index] = isTooLarge;
    } else {
      this.widget[index].file = null;
      this.fileSizeInvalid[index] = false;
    }
  }

  public get sortedWidgets() {
    // sort ascending by id
    return (this.userWidgets || []).slice().sort((a: any, b: any) => a.id - b.id);
  }

  private isLinkUrlFilled(index: number): boolean {
    return !!this.widget[index]?.linkUrl;
  }

  public async mounted() {
    this.fullPath = String(this.$route.fullPath);
    await this.findWidgets();

    // Take up to 3 widgets, and fill the rest with blank ones
    this.widget = [0, 1, 2].map((index) => {
      const widget = this.sortedWidgets[index];
      return widget ? { ...widget } : { title: "", description: "", linkUrl: "", id: null };
    });
  }

  public async onSubmit(): Promise<any> {
    this.$v.$touch();
    if (this.$v.$invalid) return;

    await this.updateWidgets(this.widget);

    if (this.fileSizeInvalid.includes(true)) {
      this.$toasted.error(String(this.$t("configuration.file_size_exceed_message")));
      return;
    }

    // 2. Upload images (only if file is set and widget has an id)
    for (const widget of this.widget) {
      if (widget.file && widget.id) {
        const formData = new FormData();
        formData.append("file", widget.file);

        await this.uploadWidgetImg({
          id: widget.id,
          file: formData,
        });
        widget.file = null;
      }
    }

    await this.findWidgets();
  }

  public onAbort(): void {
    console.log("onAbort");
    this.widget = [0, 1, 2].map((index) => {
      const widget = this.sortedWidgets[index];
      return widget ? { ...widget } : { title: "", description: "", linkUrl: "", id: null };
    });
    this.$router.push("/unterricht");
    this.closeTab(this.fullPath ?? "", this.name);
  }

  @Validations()
  public validations(): Record<string, any> {
    return {
      widget: {
        0: {
          title: {
            required: requiredIf(() => this.isLinkUrlFilled(0)),
          },
          linkUrl: { optionalUrl },
        },
        1: {
          title: {
            required: requiredIf(() => this.isLinkUrlFilled(1)),
          },
          linkUrl: { optionalUrl },
        },
        2: {
          title: {
            required: requiredIf(() => this.isLinkUrlFilled(2)),
          },
          linkUrl: { optionalUrl },
        },
      },
    };
  }
}
